import Grid, { GridProps } from "@mui/material/Grid"
import { Theme } from "@mui/material/styles"

import makeStyles from "../muiStylesCompat"

interface IOverlayProps extends GridProps {
    shouldBlurBackground?: boolean
    opacity?: number
}

interface IOverlayStyleProps {
    shouldBlurBackground: boolean
    opacity: number
}
const useStyles = makeStyles<Theme, IOverlayStyleProps>({
    container: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "100%",
        height: "100%",
        backgroundColor: (props: any) =>
            props.shouldBlurBackground
                ? `rgba(255, 255, 255, ${props.opacity})`
                : "transparent",
        zIndex: 100,
    },
})

export default function Overlay({
    shouldBlurBackground = true,
    opacity = 0.9,
    children,
}: IOverlayProps) {
    const classes = useStyles({ shouldBlurBackground, opacity })

    return (
        <>
            {children ? (
                <Grid
                    container
                    className={classes.container}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                >
                    {children}
                </Grid>
            ) : null}
        </>
    )
}
